module.exports = __webpack_public_path__ + "img/ribbon.805826fa.svg";